import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { MdClose } from 'react-icons/md'; // exemplo de ícone extra
import { BiExpandAlt } from 'react-icons/bi';

interface CardTotalProps {
  icon: React.ReactNode;
  title: string;
  total: string | number;
  isModal?: boolean;
  setModalOpen?: (open: boolean) => void;
}

export const CardTotal: React.FC<CardTotalProps> = ({
  icon,
  title,
  total,
  isModal = false,
  setModalOpen,
}) => {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleExpandClick = () => {
    if (setModalOpen) {
      setModalOpen(true);
    }
  };
  return (
    <Card
      style={{
        borderRadius: '8px',
        backgroundColor: '#fff',
        minWidth: 154,
        width: '100%',
        maxHeight: 119,
        height: '100%',
        border: 'none',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: '0.75rem',
      }}
    >
      <CardBody
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: 0,
          height: '100%',
          width: '100%',
        }}
      >
        {/* Topo - Ícones */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ color: '#2A2C85' }}>{icon}</div>
          {isModal && (
            <BiExpandAlt
              size={18}
              style={{ color: '#5A5A5A', cursor: 'pointer' }}
              onClick={handleExpandClick}
            />
          )}
        </div>

        {/* Meio - Título */}
        <h5
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 500,
            color: '#5A5A5A',
          }}
        >
          {title}
        </h5>

        {/* Fundo - Total */}
        <div
          style={{
            fontWeight: 700,
            fontSize: 18,
            color: '#2A2C85',
          }}
        >
          {total}
        </div>
      </CardBody>
    </Card>
  );
};
